import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="system-alerts"
export default class extends Controller {
  static targets = [ "container" ]

  connect() {
  }

  createAlert(style, message) {
    const alertDiv = document.createElement("div")
    alertDiv.setAttribute("class", `alert alert-${style} fixed-alert`)
    alertDiv.setAttribute("role", `alert`)

    const alertText = document.createTextNode(message)

    const dismissButton = document.createElement("button")
    dismissButton.setAttribute("aria-label", "Close")
    dismissButton.setAttribute("class", "btn-close")
    dismissButton.setAttribute("data-bs-dismiss", "alert")
    dismissButton.setAttribute("type", "button")
    // dismissButton.setAttribute("style", "height: 1.5em; width: 1.5em;")
    dismissButton.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.79289 2.79289C3.18342 2.40237 3.81658 2.40237 4.20711 2.79289L12 10.5858L19.7929 2.79289C20.1834 2.40237 20.8166 2.40237 21.2071 2.79289C21.5976 3.18342 21.5976 3.81658 21.2071 4.20711L13.4142 12L21.2071 19.7929C21.5976 20.1834 21.5976 20.8166 21.2071 21.2071C20.8166 21.5976 20.1834 21.5976 19.7929 21.2071L12 13.4142L4.20711 21.2071C3.81658 21.5976 3.18342 21.5976 2.79289 21.2071C2.40237 20.8166 2.40237 20.1834 2.79289 19.7929L10.5858 12L2.79289 4.20711C2.40237 3.81658 2.40237 3.18342 2.79289 2.79289Z" fill="white"/>
      </svg>
    `

    alertDiv.appendChild(alertText)
    alertDiv.appendChild(dismissButton)

    this.containerTarget.appendChild(alertDiv)
  } 
}
